import './src/styles/global.scss';
import './src/styles/fonts.css';

export const onRouteUpdate = () => {
	if (typeof window !== 'undefined') {
		window.scrollTo(0, 0);
	}
};
